export default __webpack_public_path__ + "static/media/i3.6eecb987.svg";